import logoPsi from "@/assets/logoPsiMammoliti.svg";

interface DevolucionPuntajeProps {
  /** Promedio de 1 a 5. */
  puntaje: number;
  className?: string;
}

/**
 * Puntaje de una devolución: el número ("4,6 de 5") y los 5 isotipos de "Calificá", con los
 * enteros llenos (redondeado). Lo usan el panel de admin (revisión) y "Devoluciones" de quien dictó.
 */
export const DevolucionPuntaje = ({ puntaje, className = "" }: DevolucionPuntajeProps) => {
  const llenos = Math.round(puntaje);
  const texto = puntaje.toLocaleString("es-AR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} aria-label={`Puntaje: ${texto} de 5`}>
      <span className="text-3xl font-extrabold leading-none text-[#2D2049]">
        {texto} <span className="text-sm font-semibold text-gray-500">de 5</span>
      </span>
      <div className="flex items-center gap-1" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((n) => (
          <img key={n} src={logoPsi} alt="" className={`h-6 w-6 ${n <= llenos ? "" : "opacity-25 grayscale"}`} />
        ))}
      </div>
    </div>
  );
};

export default DevolucionPuntaje;
